import { render, staticRenderFns } from "./SalesEdit_Details2.vue?vue&type=template&id=c49173f0&"
import script from "./SalesEdit_Details2.vue?vue&type=script&lang=js&"
export * from "./SalesEdit_Details2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports